import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const HUBSPOT_SCRIPT_SRC = 'https://js-eu1.hsforms.net/forms/embed/144975646.js';

const Kontaktformular: React.FC = () => {
  useEffect(() => {
    if (document.querySelector(`script[src="${HUBSPOT_SCRIPT_SRC}"]`)) return;
    const script = document.createElement('script');
    script.src = HUBSPOT_SCRIPT_SRC;
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <main className="flex-grow container mx-auto px-4 py-8 max-w-3xl">
        <div className="form-container fade-in">
          <div
            className="hs-form-frame"
            data-region="eu1"
            data-form-id="2c8846d5-17ed-42d3-bbb3-c8596d883f1f"
            data-portal-id="144975646"
          />
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Kontaktformular;
